import React from "react";
import Navbar from "../../components/Navbar";
import { Link } from "react-router-dom";

const PrivacyPolicyPage = () => {
  return (
    <div>
      <Navbar />
      <div className="flex flex-col items-center min-h-screen bg-gray-100">
        <div className="bg-white p-6 rounded-lg shadow-md w-full max-w-7xl max-lg:px-4 mt-10">
          <h1 className="text-3xl font-bold text-gray-800 mb-6">
            Privacy Policy
          </h1>
          <p className="text-gray-700 mb-4">
            <span className="font-semibold">Effective date:</span> 02/22/2024
          </p>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            Introduction
          </h2>
          <p className="text-gray-700 mb-4">
            Welcome to INTRAVERSE AFRICA. INTRAVERSE AFRICA (“us”, “we”, or
            “our”) operates https://www.intraverse.app and Intraverse Agent App
            mobile application (hereinafter referred to as “Service”). Our
            Privacy Policy governs your visit to https://www.intraverse.app and
            Intraverse Agent App mobile application, and explains how we
            collect, safeguard and disclose information that results from your
            use of our Service. We use your data to provide and improve Service.
            By using Service, you agree to the collection and use of information
            in accordance with this policy. Unless otherwise defined in this
            Privacy Policy, the terms used in this Privacy Policy have the same
            meanings as in our Terms and Conditions. Our Terms and Conditions
            (“Terms”) govern all use of our Service and together with the
            Privacy Policy constitutes your agreement with us (“agreement”).
          </p>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            Definitions
          </h2>
          <ul className="list-disc list-inside text-gray-700 mb-4">
            <li>
              <span className="font-semibold">SERVICE</span> means the
              https://www.intraverse.app website and Intraverse Agent App mobile
              application operated by INTRAVERSE AFRICA.
            </li>
            <li>
              <span className="font-semibold">PERSONAL DATA</span> means data
              about a living individual who can be identified from those data
              (or from those and other information either in our possession or
              likely to come into our possession).
            </li>
            <li>
              <span className="font-semibold">USAGE DATA</span> is data
              collected automatically either generated by the use of Service or
              from Service infrastructure itself (for example, the duration of a
              page visit).
            </li>
            <li>
              <span className="font-semibold">COOKIES</span> are small files
              stored on your device (computer or mobile device).
            </li>
            <li>
              <span className="font-semibold">DATA CONTROLLER</span> means a
              natural or legal person who (either alone or jointly or in common
              with other persons) determines the purposes for which and the
              manner in which any personal data are, or are to be, processed.
              For the purpose of this Privacy Policy, we are a Data Controller
              of your data.
            </li>
            <li>
              <span className="font-semibold">
                DATA PROCESSORS (OR SERVICE PROVIDERS)
              </span>{" "}
              means any natural or legal person who processes the data on behalf
              of the Data Controller. We may use the services of various Service
              Providers in order to process your data more effectively.
            </li>
            <li>
              <span className="font-semibold">DATA SUBJECT</span> is any living
              individual who is the subject of Personal Data.
            </li>
            <li>
              <span className="font-semibold">THE USER</span> is the individual
              using our Service. The User corresponds to the Data Subject, who
              is the subject of Personal Data.
            </li>
          </ul>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            Information Collection and Use
          </h2>
          <p className="text-gray-700 mb-4">
            We collect several different types of information for various
            purposes to provide and improve our Service to you.
          </p>
          <h3 className="text-xl font-semibold text-gray-800 mb-4">
            Types of Data Collected
          </h3>
          <h4 className="text-lg font-semibold text-gray-800 mb-2">
            Personal Data
          </h4>
          <p className="text-gray-700 mb-4">
            While using our Service, we may ask you to provide us with certain
            personally identifiable information that can be used to contact or
            identify you (“Personal Data”). Personally identifiable information
            may include, but is not limited to:
          </p>
          <ul className="list-disc list-inside text-gray-700 mb-4">
            <li>Email address</li>
            <li>First name and last name</li>
            <li>Phone number</li>
            <li>Address, State, Province, ZIP/Postal code, City</li>
            <li>Cookies and Usage Data</li>
          </ul>
          <p className="text-gray-700 mb-4">
            We may use your Personal Data to contact you with newsletters,
            marketing or promotional materials and other information that may be
            of interest to you. You may opt out of receiving any, or all, of
            these communications from us by following the unsubscribe link or by
            emailing at support@intraverse.africa.
          </p>
          <h4 className="text-lg font-semibold text-gray-800 mb-2">
            Usage Data
          </h4>
          <p className="text-gray-700 mb-4">
            We may also collect information that your browser sends whenever you
            visit our Service or when you access Service by or through a mobile
            device (“Usage Data”). This Usage Data may include information such
            as your computer's Internet Protocol address (e.g. IP address),
            browser type, browser version, the pages of our Service that you
            visit, the time and date of your visit, the time spent on those
            pages, unique device identifiers and other diagnostic data. When you
            access Service with a mobile device, this Usage Data may include
            information such as the type of mobile device you use, your mobile
            device unique ID, the IP address of your mobile device, your mobile
            operating system, the type of mobile Internet browser you use,
            unique device identifiers and other diagnostic data.
          </p>
          <h4 className="text-lg font-semibold text-gray-800 mb-2">
            Tracking Cookies Data
          </h4>
          <p className="text-gray-700 mb-4">
            We use cookies and similar tracking technologies to track the
            activity on our Service and we hold certain information. Cookies are
            files with a small amount of data which may include an anonymous
            unique identifier. Cookies are sent to your browser from a website
            and stored on your device. Other tracking technologies are also used
            such as beacons, tags and scripts to collect and track information
            and to improve and analyze our Service. You can instruct your
            browser to refuse all cookies or to indicate when a cookie is being
            sent. However, if you do not accept cookies, you may not be able to
            use some portions of our Service.
          </p>
          <h5 className="text-base font-semibold text-gray-800 mb-2">
            Examples of Cookies we use:
          </h5>
          <ul className="list-disc list-inside text-gray-700 mb-4">
            <li>
              <span className="font-semibold">Session Cookies:</span> We use
              Session Cookies to operate our Service.
            </li>
            <li>
              <span className="font-semibold">Preference Cookies:</span> We use
              Preference Cookies to remember your preferences and various
              settings.
            </li>
            <li>
              <span className="font-semibold">Security Cookies:</span> We use
              Security Cookies for security purposes.
            </li>
            <li>
              <span className="font-semibold">Advertising Cookies:</span>{" "}
              Advertising Cookies are used to serve you with advertisements that
              may be relevant to you and your interests.
            </li>
          </ul>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            Use of Data
          </h2>
          <p className="text-gray-700 mb-4">
            INTRAVERSE AFRICA uses the collected data for various purposes:
          </p>
          <ul className="list-disc list-inside text-gray-700 mb-4">
            <li>to provide and maintain our Service;</li>
            <li>to notify you about changes to our Service;</li>
            <li>
              to allow you to participate in interactive features of our Service
              when you choose to do so;
            </li>
            <li>to provide customer support;</li>
            <li>
              to gather analysis or valuable information so that we can improve
              our Service;
            </li>
            <li>to monitor the usage of our Service;</li>
            <li>to detect, prevent and address technical issues;</li>
            <li>to fulfill any other purpose for which you provide it;</li>
            <li>
              to carry out our obligations and enforce our rights arising from
              any contracts entered into between you and us, including for
              billing and collection;
            </li>
            <li>
              to provide you with notices about your account and/or
              subscription, including expiration and renewal notices,
              email-instructions, etc.;
            </li>
            <li>
              to provide you with news, special offers and general information
              about other goods, services and events which we offer that are
              similar to those that you have already purchased or enquired about
              unless you have opted not to receive such information;
            </li>
            <li>
              in any other way we may describe when you provide the information;
            </li>
            <li>for any other purpose with your consent.</li>
          </ul>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            Retention of Data
          </h2>
          <p className="text-gray-700 mb-4">
            We will retain your Personal Data only for as long as is necessary
            for the purposes set out in this Privacy Policy. We will retain and
            use your Personal Data to the extent necessary to comply with our
            legal obligations (for example, if we are required to retain your
            data to comply with applicable laws), resolve disputes, and enforce
            our legal agreements and policies.
          </p>
          <p className="text-gray-700 mb-4">
            We will also retain Usage Data for internal analysis purposes. Usage
            Data is generally retained for a shorter period, except when this
            data is used to strengthen the security or to improve the
            functionality of our Service, or we are legally obligated to retain
            this data for longer time periods.
          </p>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            Transfer of Data
          </h2>
          <p className="text-gray-700 mb-4">
            Your information, including Personal Data, may be transferred to –
            and maintained on – computers located outside of your state,
            province, country or other governmental jurisdiction where the data
            protection laws may differ from those of your jurisdiction.
          </p>
          <p className="text-gray-700 mb-4">
            If you are located outside Nigeria and choose to provide information
            to us, please note that we transfer the data, including Personal
            Data, to our servers located in different locations outside Nigeria
            and process it there.
          </p>
          <p className="text-gray-700 mb-4">
            Your consent to this Privacy Policy followed by your submission of
            such information represents your agreement to that transfer.
            INTRAVERSE AFRICA will take all the steps reasonably necessary to
            ensure that your data is treated securely and in accordance with
            this Privacy Policy and no transfer of your Personal Data will take
            place to an organisation or a country unless there are adequate
            controls in place including the security of your data and other
            personal information.
          </p>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            Disclosure of Data
          </h2>
          <p className="text-gray-700 mb-4">
            We may disclose personal information that we collect, or you
            provide:
          </p>
          <ul className="list-disc list-inside text-gray-700 mb-4">
            <li>
              <span className="font-semibold">
                Disclosure for Law Enforcement.
              </span>{" "}
              Under certain circumstances, we may be required to disclose your
              Personal Data if required to do so by law or in response to valid
              requests by public authorities.
            </li>
            <li>
              <span className="font-semibold">Business Transaction.</span> If we
              or our subsidiaries are involved in a merger, acquisition or asset
              sale, your Personal Data may be transferred.
            </li>
            <li>
              <span className="font-semibold">Other cases.</span> We may
              disclose your information also: to our subsidiaries and
              affiliates;
            </li>
          </ul>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            Security of Data
          </h2>
          <p className="text-gray-700 mb-4">
            The security of your data is important to us but remember that no
            method of transmission over the Internet or method of electronic
            storage is 100% secure. While we strive to use commercially
            acceptable means to protect your Personal Data, we cannot guarantee
            its absolute security.
          </p>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            Your Data Protection Rights Under General Data Protection Regulation
            (GDPR)
          </h2>
          <p className="text-gray-700 mb-4">
            If you are a resident of the European Union (EU) and European
            Economic Area (EEA), you have certain data protection rights,
            covered by GDPR. – See more at
            <Link
              className="link-overflow"
              to="https://eur-lex.europa.eu/eli/reg/2016/679/oj"
            >
              https://eur-lex.europa.eu/eli/reg/2016/679/oj
            </Link>
          </p>
          <p className="text-gray-700 mb-4">
            We aim to take reasonable steps to allow you to correct, amend,
            delete, or limit the use of your Personal Data.
          </p>
          <p className="text-gray-700 mb-4">
            If you wish to be informed what Personal Data we hold about you and
            if you want it to be removed from our systems, please email us at
            support@intraverse.africa.
          </p>
          <p className="text-gray-700 mb-4">
            In certain circumstances, you have the following data protection
            rights:
          </p>
          <ul className="list-disc list-inside text-gray-700 mb-4">
            <li>
              the right to access, update or to delete the information we have
              on you;
            </li>
            <li>
              the right of rectification. You have the right to have your
              information rectified if that information is inaccurate or
              incomplete;
            </li>
            <li>
              the right to object. You have the right to object to our
              processing of your Personal Data;
            </li>
            <li>
              the right of restriction. You have the right to request that we
              restrict the processing of your personal information;
            </li>
            <li>
              the right to data portability. You have the right to be provided
              with a copy of your Personal Data in a structured,
              machine-readable and commonly used format;
            </li>
            <li>
              the right to withdraw consent. You also have the right to withdraw
              your consent at any time where we rely on your consent to process
              your personal information;
            </li>
          </ul>
          <p className="text-gray-700 mb-4">
            Please note that we may ask you to verify your identity before
            responding to such requests. Please note, we may not able to provide
            Service without some necessary data.
          </p>
          <p className="text-gray-700 mb-4">
            You have the right to complain to a Data Protection Authority about
            our collection and use of your Personal Data. For more information,
            please contact your local data protection authority in the European
            Economic Area (EEA).
          </p>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            Service Providers
          </h2>
          <p className="text-gray-700 mb-4">
            We may employ third party companies and individuals to facilitate
            our Service (“Service Providers”), provide Service on our behalf,
            perform Service-related services or assist us in analysing how our
            Service is used.
          </p>
          <p className="text-gray-700 mb-4">
            These third parties have access to your Personal Data only to
            perform these tasks on our behalf and are obligated not to disclose
            or use it for any other purpose.
          </p>
          <h3 className="text-xl font-semibold text-gray-800 mb-4">
            Analytics
          </h3>
          <p className="text-gray-700 mb-4">
            We may use third-party Service Providers to monitor and analyze the
            use of our Service.
          </p>
          <h4 className="text-lg font-semibold text-gray-800 mb-2">
            Google Analytics
          </h4>
          <p className="text-gray-700 mb-4">
            Google Analytics is a web analytics service offered by Google that
            tracks and reports website traffic. Google uses the data collected
            to track and monitor the use of our Service. This data is shared
            with other Google services. Google may use the collected data to
            contextualise and personalise the ads of its own advertising
            network.
          </p>
          <p className="text-gray-700 mb-4">
            For more information on the privacy practices of Google, please
            visit the Google Privacy Terms web page:
            <Link
              className="link-overflow"
              to="https://policies.google.com/privacy?hl=en"
            >
              https://policies.google.com/privacy?hl=en
            </Link>
            We also encourage you to review the Google's policy for safeguarding
            your data:
            <Link
              className="link-overflow"
              to="https://support.google.com/analytics/answer/6004245"
            >
              https://support.google.com/analytics/answer/6004245
            </Link>
            .
          </p>
          <h4 className="text-lg font-semibold text-gray-800 mb-2">Firebase</h4>
          <p className="text-gray-700 mb-4">
            Firebase is analytics service provided by Google Inc. You may
            opt-out of certain Firebase features through your mobile device
            settings, such as your device advertising settings or by following
            the instructions provided by Google in their Privacy Policy:
            https://policies.google.com/privacy?hl=en For more information on
            what type of information Firebase collects, please visit the Google
            Privacy Terms web page:
            <Link
              className="link-overflow"
              to="https://policies.google.com/privacy?hl=en"
            >
              https://policies.google.com/privacy?hl=en
            </Link>
          </p>
          <h4 className="text-lg font-semibold text-gray-800 mb-2">
            Segment.io
          </h4>
          <p className="text-gray-700 mb-4">
            Segment.io is a web traffic analysis tool. You can read the Privacy
            Policy for Segment.io here:
            <Link
              className="link-overflow"
              to="https://segment.com/legal/privacy/"
            >
              https://segment.com/legal/privacy/
            </Link>
            .
          </p>
          <h4 className="text-lg font-semibold text-gray-800 mb-2">Mixpanel</h4>
          <p className="text-gray-700 mb-4">
            Mixpanel is provided by Mixpanel Inc. You can prevent Mixpanel from
            using your information for analytics purposes by opting-out. To
            opt-out of Mixpanel service, please visit this page:
            <Link className="link-overflow" to="https://mixpanel.com/optout/">
              https://mixpanel.com/optout/
            </Link>
            For more information on what type of information Mixpanel collects,
            please visit the Terms of Use page of Mixpanel:
            <Link className="link-overflow" to="https://mixpanel.com/terms/">
              https://mixpanel.com/terms/
            </Link>
          </p>
          <h3 className="text-xl font-semibold text-gray-800 mb-4">
            CI/CD tools
          </h3>
          <p className="text-gray-700 mb-4">
            We may use third-party Service Providers to automate the development
            process of our Service.
          </p>
          <h4 className="text-lg font-semibold text-gray-800 mb-2">GitHub</h4>
          <p className="text-gray-700 mb-4">
            GitHub is provided by GitHub, Inc. GitHub is a development platform
            to host and review code, manage projects, and build software. For
            more information on what data GitHub collects for what purpose and
            how the protection of the data is ensured, please visit GitHub
            Privacy Policy page:
            <Link
              className="link-overflow"
              to="https://help.github.com/en/articles/github-privacy-statement"
            >
              https://help.github.com/en/articles/github-privacy-statement
            </Link>
            .
          </p>
          <h4 className="text-lg font-semibold text-gray-800 mb-2">
            GitLab CI/CD
          </h4>
          <p className="text-gray-700 mb-4">
            GitLab CI/CD is provided by GitLab, Inc. GitLab CI (Continuous
            Integration) service is a part of GitLab that build and test the
            software whenever developer pushes code to application. GitLab CD
            (Continuous Deployment) is a software service that places the
            changes of every code in the production which results in every day
            deployment of production. For more information on what data GitLab
            CI/CD collects for what purpose and how the protection of the data
            is ensured, please visit GitLab CI/CD Privacy Policy page:
            <Link
              className="link-overflow"
              to="https://about.gitlab.com/privacy/"
            >
              https://about.gitlab.com/privacy/
            </Link>
            .
          </p>
          <h3 className="text-xl font-semibold text-gray-800 mb-4">
            Behavioral Remarketing
          </h3>
          <p className="text-gray-700 mb-4">
            INTRAVERSE AFRICA uses remarketing services to advertise on third
            party websites to you after you visited our Service. We and our
            third-party vendors use cookies to inform, optimise and serve ads
            based on your past visits to our Service.
          </p>
          <h4 className="text-lg font-semibold text-gray-800 mb-2">
            Google Ads (AdWords)
          </h4>
          <p className="text-gray-700 mb-4">
            Google Ads (AdWords) remarketing service is provided by Google Inc.
            You can opt-out of Google Analytics for Display Advertising and
            customize the Google Display Network ads by visiting the Google Ads
            Settings page:
            <Link
              className="link-overflow"
              to="http://www.google.com/settings/ads"
            >
              http://www.google.com/settings/ads
            </Link>
            Google also recommends installing the Google Analytics Opt-out
            Browser Add-on:
            <Link
              className="link-overflow"
              to="https://tools.google.com/dlpage/gaoptout"
            >
              https://tools.google.com/dlpage/gaoptout
            </Link>
            For more information on the privacy practices of Google, please
            visit the Google Privacy Terms web page:
            <Link
              className="link-overflow"
              to="https://policies.google.com/privacy?hl=en"
            >
              https://policies.google.com/privacy?hl=en
            </Link>
          </p>
          <h4 className="text-lg font-semibold text-gray-800 mb-2">Facebook</h4>
          <p className="text-gray-700 mb-4">
            Facebook remarketing service is provided by Facebook Inc. You can
            learn more about interest-based advertising from Facebook by
            visiting this page:
            <Link
              className="link-overflow"
              to="https://www.facebook.com/help/164968693837950"
            >
              https://www.facebook.com/help/164968693837950
            </Link>
            To opt-out from Facebook's interest-based ads, follow these
            instructions from Facebook:
            <Link
              className="link-overflow"
              to="https://www.facebook.com/help/568137493302217"
            >
              https://www.facebook.com/help/568137493302217
            </Link>
            For more information on the privacy practices of Facebook, please
            visit Facebook's Data Policy:
            <Link
              className="link-overflow"
              to="https://www.facebook.com/privacy/explanation"
            >
              https://www.facebook.com/privacy/explanation
            </Link>
          </p>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            Payments
          </h2>
          <p className="text-gray-700 mb-4">
            We may provide paid products and/or services within Service. In that
            case, we use third-party services for payment processing (e.g.
            payment processors). We will not store or collect your payment card
            details. That information is provided directly to our third-party
            payment processors whose use of your personal information is
            governed by their Privacy Policy. These payment processors adhere to
            the standards set by PCI-DSS as managed by the PCI Security
            Standards Council, which is a joint effort of brands like Visa,
            Mastercard, American Express and Discover. PCI-DSS requirements help
            ensure the secure handling of payment information.
          </p>
          <p className="text-gray-700 mb-4">
            The payment processors we work with are: Paystack: Their Privacy
            Policy can be viewed at
            <Link
              className="link-overflow"
              to="https://paystack.com/privacy/merchant"
            >
              https://paystack.com/privacy/merchant
            </Link>
            <br />
            <Link
              className="link-overflow"
              to="https://www.paypal.com/webapps/mpp/ua/privacy-full"
            >
              https://www.paypal.com/webapps/mpp/ua/privacy-full
            </Link>
          </p>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            Links to Other Sites
          </h2>
          <p className="text-gray-700 mb-4">
            Our Service may contain links to other sites that are not operated
            by us. If you click a third party link, you will be directed to that
            third party's site. We strongly advise you to review the Privacy
            Policy of every site you visit. We have no control over and assume
            no responsibility for the content, privacy policies or practices of
            any third party sites or services.
          </p>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            Children's Privacy
          </h2>
          <p className="text-gray-700 mb-4">
            Our Services are not intended for use by children under the age of
            13 (“Children”). We do not knowingly collect personally identifiable
            information from Children under 13. If you become aware that a Child
            has provided us with Personal Data, please contact us. If we become
            aware that we have collected Personal Data from Children without
            verification of parental consent, we take steps to remove that
            information from our servers.
          </p>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            Changes to This Privacy Policy
          </h2>
          <p className="text-gray-700 mb-4">
            We may update our Privacy Policy from time to time. We will notify
            you of any changes by posting the new Privacy Policy on this page.
            We will let you know via email and/or a prominent notice on our
            Service, prior to the change becoming effective and update
            “effective date” at the top of this Privacy Policy.
          </p>
          <p className="text-gray-700 mb-4">
            You are advised to review this Privacy Policy periodically for any
            changes. Changes to this Privacy Policy are effective when they are
            posted on this page.
          </p>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            Contact Us
          </h2>
          <p className="text-gray-700 mb-4">
            If you have any questions about this Privacy Policy, please contact
            us:
          </p>
          <p className="text-gray-700 mb-4">
            By email: support@intraverse.africa.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
